import React from "react";
import style from "./commoncard.module.scss";

const FrameCard = ({ children }) => {
  return (
    <div className={`${style.cardwrapper} overflow-hidden`}>
      <div className={style.cardwrapperbody}> {children}</div>
    </div>
  );
};

export default FrameCard;
